import { render, staticRenderFns } from "./BuildingBulkDeliveryCreate.vue?vue&type=template&id=4f6b4e6c"
import script from "./BuildingBulkDeliveryCreate.vue?vue&type=script&lang=ts"
export * from "./BuildingBulkDeliveryCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports